import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const TarjetaHorizontal = ({ CustomIcon, title, text, secondary }) => {
    return (
        <Card className="tarjeta-horizontal">
            <Card.Body>
                <Container>
                    <Row>
                        <Col lg={3} md={3} sm={3} xs={3} className="card-number">
                            <span className={secondary ? "card-circle-secondary" : "card-circle"}>
                                <img src={CustomIcon} alt="Icono" />
                            </span>
                        </Col>
                        <Col lg={9} md={9} sm={9} xs={9}>
                            <Card.Title>{title}</Card.Title>
                            <Card.Text>
                                {text}
                            </Card.Text>
                        </Col>
                    </Row>
                </Container>
            </Card.Body>
        </Card>
    );
};

export default TarjetaHorizontal;